export default "__VITE_ASSET__DzAROA_Y__"